var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM4.5 6a1 1 0 011-1h1a1 1 0 011 1v4.5a1 1 0 01-1 1h-1a1 1 0 01-1-1V6z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgMy41QzYuODI4NDMgMy41IDcuNSAyLjgyODQzIDcuNSAyQzcuNSAxLjE3MTU3IDYuODI4NDMgMC41IDYgMC41QzUuMTcxNTcgMC41IDQuNSAxLjE3MTU3IDQuNSAyQzQuNSAyLjgyODQzIDUuMTcxNTcgMy41IDYgMy41WiIgLz4KPHBhdGggZD0iTTQuNSA2QzQuNSA1LjQ0NzcyIDQuOTQ3NzIgNSA1LjUgNUg2LjVDNy4wNTIyOCA1IDcuNSA1LjQ0NzcyIDcuNSA2VjEwLjVDNy41IDExLjA1MjMgNy4wNTIyOCAxMS41IDYuNSAxMS41SDUuNUM0Ljk0NzcyIDExLjUgNC41IDExLjA1MjMgNC41IDEwLjVWNloiIC8+Cjwvc3ZnPgo=";
export { SvgInfo as ReactComponent };